import { Link } from "react-router-dom";

export const Footer = () => (
  <footer className="site" data-testid="site-footer">
    <div className="wrap foot-grid">
      <div className="foot-brand">
        <img
          src="/brand/asia-sourcing-logo.png"
          alt="Asia Sourcing — Sourcing & Quality Control"
          width="1502"
          height="560"
          loading="lazy"
          decoding="async"
          style={{ width: "100%", maxWidth: 320, height: "auto", marginBottom: "1rem", borderRadius: 6 }}
        />
        <p style={{ fontFamily: "var(--mono)", fontSize: ".68rem", letterSpacing: ".1em", textTransform: "uppercase", color: "rgba(239,234,224,.55)", marginTop: ".8rem", lineHeight: 1.7 }}>
          D-8 Manarover Colony · Delhi Road<br />
          Moradabad 244001 · India<br />
          +91 90123 02222
        </p>
        <div className="certs">
          <span>BSCI</span>
          <span>Sedex</span>
          <span>ISO 9001</span>
          <span>FSC</span>
          <span>GOTS</span>
        </div>
      </div>
      <div>
        <h4>Categories</h4>
        <ul>
          <li><Link to="/categories/lighting">Lighting</Link></li>
          <li><Link to="/categories/furniture">Furniture</Link></li>
          <li><Link to="/categories/home-decor">Home décor</Link></li>
          <li><Link to="/categories/textile">Textile</Link></li>
          <li><Link to="/categories/brass-metalware">Brass &amp; metalware</Link></li>
          <li><Link to="/categories/fashion-accessories">Fashion accessories</Link></li>
        </ul>
      </div>
      <div>
        <h4>Clusters</h4>
        <ul>
          <li><Link to="/clusters/moradabad">Moradabad</Link></li>
          <li><Link to="/clusters/jaipur">Jaipur</Link></li>
          <li><Link to="/clusters/jodhpur">Jodhpur</Link></li>
          <li><Link to="/clusters/panipat">Panipat</Link></li>
          <li><Link to="/clusters/firozabad">Firozabad</Link></li>
          <li><Link to="/clusters/saharanpur">Saharanpur</Link></li>
          <li><Link to="/clusters/noida">Noida</Link></li>
          <li><Link to="/clusters/delhi">Delhi</Link></li>
          <li><Link to="/clusters/bhadohi">Bhadohi</Link></li>
          <li><Link to="/clusters/varanasi">Varanasi</Link></li>
          <li><Link to="/clusters/agra">Agra</Link></li>
          <li><Link to="/clusters/gurugram">Gurugram</Link></li>
          <li><Link to="/clusters/channapatna">Channapatna</Link></li>
          <li><Link to="/clusters/karur">Karur</Link></li>
          <li><Link to="/clusters/kashmir">Kashmir</Link></li>
          <li><Link to="/clusters">All 15 clusters →</Link></li>
        </ul>
      </div>
      <div>
        <h4>Services</h4>
        <ul>
          <li><Link to="/services/buying-agent-india">Buying Agent India</Link></li>
          <li><Link to="/services/quality-inspection-india">Quality Inspection</Link></li>
          <li><Link to="/services/pre-shipment-inspection">Pre-Shipment Inspection</Link></li>
          <li><Link to="/services/factory-audit-india">Factory Audit</Link></li>
          <li><Link to="/services/product-development">Product Development</Link></li>
          <li><Link to="/services">All services →</Link></li>
        </ul>
      </div>
      <div>
        <h4>Regions</h4>
        <ul>
          <li><Link to="/regions/usa">USA</Link></li>
          <li><Link to="/regions/uk">United Kingdom</Link></li>
          <li><Link to="/regions/germany">Germany</Link></li>
          <li><Link to="/regions/middle-east">Middle East / GCC</Link></li>
          <li><Link to="/regions/australia">Australia</Link></li>
          <li><Link to="/regions">All regions →</Link></li>
        </ul>
      </div>
      <div>
        <h4>House</h4>
        <ul>
          <li><Link to="/about">About</Link></li>
          <li><Link to="/work">Work</Link></li>
          <li><Link to="/case-studies">Case studies</Link></li>
          <li><Link to="/programmes">Illustrative programmes</Link></li>
          <li><Link to="/trends">Insights</Link></li>
          <li><Link to="/contact">Contact</Link></li>
          <li><Link to="/start-a-project">Start a project</Link></li>
        </ul>
      </div>
    </div>
    <div className="wrap foot-base">
      <span>© {new Date().getFullYear()} Asia Sourcing</span>
      <span>Craft-to-container · India</span>
    </div>
  </footer>
);

export default Footer;
